<template>
	<v-autocomplete class="TagsFieldCheckbox" v-model="model" :chips="chips" :items="options" :item-title="itemTitle"
		:item-value="itemValue" :returnObject="returnObject" multiple hideDetails="true" variant="outlined"
		:singleLine="true" :closable-chips="closableChips" :clearable="false" item-props.color="#00aeef"
		color="#00aeef" :placeholder="placeholder">
		<template #chip="{ item, index }">
			<v-chip v-bind="item" :closable="closableChips" @click:close="removeChip(index, $event)"
				@mousedown="preventDefault($event)">
				{{ item.title }}
			</v-chip>
		</template>
		<template #item="{ item, props }">
			<v-list-item class="tags-field-checbox-list-item" v-bind="props">
				<template v-slot:prepend="{ isActive }">
					<v-list-item-action start>
						<v-checkbox-btn :model-value="isActive" color="#00aeef"></v-checkbox-btn>
					</v-list-item-action>
				</template>
				<template #title>
					<span>{{ item.title }}</span>
				</template>
			</v-list-item>
		</template>
	</v-autocomplete>
</template>

<script>
import { field } from './FieldMixin.js'

export default {
	name: 'TagsField',
	mixins: [field],
	props: {
		modelValue: Array,
		options: Array,
		label: String,
		locale: String,
		returnObject: String,
		placeholder: String,
		closableChips: { type: Boolean, default: true },
		chips: { type: Boolean, default: true },
		itemValue: { type: String, default: 'id' },
	},
	data() {
		return {
			model: this.modelValue
		}
	},
	emits: ['click', 'update:modelValue'],
	methods: {
		itemTitle(item) {
			return item.title?.[this.locale] ?? item.title?.de ?? item.title
		},
		preventDefault(event) {
			event.stopPropagation()
			event.preventDefault()
		},
		removeChip(index, event) {
			this.preventDefault(event)
			this.model.splice(index, 1)
		},
		validateRequired() {
			if (this.validations.required && (!this.model || (Array.isArray(this.model) && !this.model.length))) {
				return { id: this.validations.required.message ?? 'required' }
			}
		},
		validate() {
			this.onErrors([this.validateRequired()])
		}
	},
	watch: {
		model: {
			handler(value) {
				this.$emit('update:modelValue', value)
				this.validate()
			},
			deep: true
		},
		modelValue(modelValue) {
			this.model = modelValue
		}
	},
	mounted() {
		this.$nextTick(() => {
			if (!this.modelValue) {
				this.$emit('update:modelValue', [])
			}
		})
		this.validate()
	}
}
</script>

<style lang="scss">
.v-list:has(.tags-field-checbox-list-item) {
	padding: 0px;
	.tags-field-checbox-list-item {
		padding-inline: 12px;
		min-height: 60px;
		padding-top: 7px;
		padding-bottom: 7px;
		border-bottom: 1px solid #e5e5e5;
		font-size: 15px;
		line-height: 1.33;
		letter-spacing: -0.25px;

		.v-list-item__overlay {
			display: none;
		}
		&:hover {
			cursor: pointer !important;
		}
		.v-list-item__spacer {
			display: none;
		}
		.v-list-item-action {
			margin-inline-end: 0px;
		}
		&.v-list-item--active {
			color: inherit !important;
		}
	}
}
</style>

<style lang="scss" scoped>
.TagsFieldCheckbox {
	outline: none;
	box-shadow: rgb(225 228 232 / 20%) 0px 2px 0px inset;
	box-sizing: border-box;
	background-color: white;
	border: 1px solid var(--col-line);
	border-radius: 6px;
	&:focus-within {
		border-color: rgb(0, 89, 200);
		box-shadow: rgb(152 203 255) 0px 0px 0px 3px;
	}
	:deep() {
		.v-field__input {
			padding: 8px 0.75rem;
			min-height: 40px;
			color: rgb(65, 77, 99);
			font-size: 0.875rem;
			line-height: 1.25rem;
		}

		.v-field__outline,
		.v-field__clearable {
			display: none;
		}

		.v-field__overlay {
			background-color: white !important;
		}

		.v-autocomplete__selection > .v-chip {
			height: 24px;
			border-radius: 4px;
			.v-chip__underlay {
				background: #DBDBDB;
				opacity: 1;
			}
			.v-chip__content {
				z-index: 1;
			}
		}
	}
}
</style>
